module.exports = __webpack_public_path__ + "img/product2.672d7495.png";